const points = [
  { label: "Centro de Cantanhede", value: "5 min" },
  { label: "Praia Fluvial Olhos da Fervença", value: "5 km" },
  { label: "Coimbra", value: "20 km" },
  { label: "Figueira da Foz", value: "35 km" },
  { label: "Aveiro", value: "45 km" },
  { label: "Acesso A17 / A14", value: "Direto" },
  { label: "Hospital e Centro de Saúde", value: "Próximo" },
  { label: "Escolas, comércio e serviços", value: "A pé" },
];

export default function Location() {
  return (
    <section id="localizacao" data-testid="location-section" className="py-24 lg:py-36 bg-[#F1F1EC]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5 reveal">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#5C5C59] mb-6">Localização Estratégica</div>
            <h2 className="font-display text-[36px] sm:text-[44px] lg:text-[56px] leading-[1.05] tracking-[-0.02em] text-[#1A1A1A] text-balance">
              No centro de tudo.
              <br />
              <span className="italic-display text-[#2B3B31]">A distância certa.</span>
            </h2>
            <p className="mt-8 text-[15px] leading-relaxed text-[#5C5C59] font-light max-w-md">
              Cantanhede afirma-se como eixo estratégico entre Coimbra, Aveiro e Figueira da Foz, com acesso direto às autoestradas A17 e A14.
            </p>
          </div>

          <div className="lg:col-span-7 reveal" style={{ transitionDelay: "120ms" }}>
            <div className="bg-[#F9F9F6] border border-[#E5E5DF]">
              <div className="aspect-[16/9] w-full">
                <iframe
                  data-testid="location-map"
                  title="Localização ANREÁL Residence — Cantanhede"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5033.0254378542995!2d-8.605675535473903!3d40.337938163642136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd23ad0002a14a55%3A0x589eb8b9c649b93e!2sANREAL%20Residence%20-%20Condom%C3%ADnio%20Privado!5e1!3m2!1spt-PT!2spt!4v1783361234040!5m2!1spt-PT!2spt"
                  className="w-full h-full"
                  style={{ border: 0 }}
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="strict-origin-when-cross-origin"
                />
              </div>
              <div className="flex items-center justify-end px-6 py-4 border-t border-[#E5E5DF] text-[12px] tracking-[0.18em] uppercase text-[#5C5C59]">
                <a
                  href="https://www.google.com/maps/place/ANREAL+Residence+-+Condom%C3%ADnio+Privado/@40.3379382,-8.6056755,17.5z/data=!4m6!3m5!1s0xd23ad0002a14a55:0x589eb8b9c649b93e"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="location-map-link"
                  className="text-[#2B3B31] border-b border-[#2B3B31]/40 hover:border-[#2B3B31] pb-0.5"
                >
                  Abrir no Google Maps
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 lg:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E5E5DF] border border-[#E5E5DF]">
          {points.map((p, i) => (
            <div
              key={p.label}
              data-testid={`location-point-${i}`}
              className="bg-[#F9F9F6] p-6 lg:p-8 reveal"
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              <div className="font-display text-2xl lg:text-3xl text-[#2B3B31] mb-2 tracking-tight">{p.value}</div>
              <div className="text-[12px] tracking-[0.18em] uppercase text-[#5C5C59]">{p.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
